export default __webpack_public_path__ + "static/media/back.404bc431.svg";